export default {
  'shipping.h1': 'USFans Shipping Cost: Complete Guide to Fees & Delivery',
  'shipping.lead': 'Understand how USFans shipping works, what factors affect the final shipping cost, and how to estimate delivery before you order.',
  'shipping.category': 'Shipping',
  'shipping.shortTitle': 'USFans Shipping Cost',
  'shipping.readTime': '7 min read',
  'shipping.toc': 'Table of Contents',

  'shipping.s1.title': 'How Shipping Works',
  'shipping.s1.p1': 'USFans ships orders from its warehouse to the address you provide at checkout. After an order is placed, the item is picked, packaged and handed to the shipping carrier, which then delivers it according to the selected method.',
  'shipping.s1.p2': 'Because orders can vary in size, weight and destination, the shipping cost is usually calculated at checkout rather than shown as a single flat price for everyone.',

  'shipping.s2.title': 'What Affects the Cost',
  'shipping.s2.p1': 'Several factors influence the final shipping cost. The destination is often the biggest one — international and long-distance deliveries typically cost more than local ones. The weight and size of the order also matter, since larger or heavier packages cost more to transport.',
  'shipping.s2.p2': 'The chosen shipping method plays a role too. Faster or tracked options usually come at a higher price, while standard or economy options are generally cheaper but slower.',

  'shipping.s3.title': 'Estimating Delivery Time',
  'shipping.s3.p1': 'Delivery time depends on the destination, the carrier and the shipping method. Local orders usually arrive faster, while international orders can take longer due to customs and distance.',
  'shipping.s3.p2': 'The most accurate estimate is the one shown on the checkout or product page at the time you order. Treat any general estimates as a guide rather than a guarantee.',

  'shipping.s4.title': 'Common Shipping Options',
  'shipping.s4.p1': 'Most online stores, including USFans, offer a few shipping tiers. Standard shipping is the economical choice, while express options prioritize speed. Some orders may also offer tracking for extra peace of mind.',
  'shipping.s4.p2': 'Choosing the right option is a balance between cost and speed. If you are not in a hurry, standard shipping usually offers the best value; if timing matters, a faster method may be worth the extra cost.',

  'shipping.s5.title': 'Shipping Methods Compared',
  'shipping.s5.p1': 'The table below compares typical shipping approaches to help you decide which one fits your needs.',
  'shipping.table.c1': 'Method',
  'shipping.table.c2': 'Speed',
  'shipping.table.c3': 'Cost',
  'shipping.table.c4': 'Best for',
  'shipping.table.r1c1': 'Standard',
  'shipping.table.r1c2': 'Slower',
  'shipping.table.r1c3': 'Lowest',
  'shipping.table.r1c4': 'Budget shoppers',
  'shipping.table.r2c1': 'Express',
  'shipping.table.r2c2': 'Fast',
  'shipping.table.r2c3': 'Higher',
  'shipping.table.r2c4': 'Urgent orders',
  'shipping.table.r3c1': 'Tracked',
  'shipping.table.r3c2': 'Varies',
  'shipping.table.r3c3': 'Moderate',
  'shipping.table.r3c4': 'Peace of mind',
  'shipping.table.r4c1': 'International',
  'shipping.table.r4c2': 'Slowest',
  'shipping.table.r4c3': 'Highest',
  'shipping.table.r4c4': 'Overseas buyers',

  'shipping.s6.title': 'Checking the Final Price',
  'shipping.s6.p1': 'The total cost of an order is made up of the item price plus shipping and any applicable fees. Always review the full total at checkout before confirming, so there are no surprises.',
  'shipping.s6.p2': 'If the shipping cost seems unclear, the checkout summary or the store\'s shipping information page is the best place to find the current, accurate details.',

  'shipping.s7.title': 'Shipping Tips',
  'shipping.s7.p1': 'To keep costs reasonable, consider grouping multiple items into a single order when possible, and choose a shipping method that matches your actual urgency. Planning ahead can help you avoid paying for faster shipping you do not really need.',
  'shipping.s7.p2': 'Always double-check the delivery address before placing the order, since an incorrect address can cause delays or additional fees.',

  'shipping.conclusion.title': 'Summary',
  'shipping.conclusion.p1': 'USFans shipping cost is driven by destination, order size and the chosen method. By understanding these factors, you can estimate delivery and choose the option that best fits your budget and timeline.',
  'shipping.conclusion.p2': 'For current prices and delivery estimates, check the official store directly. Explore the categories on the homepage to get started.',

  'shipping.cta': 'Check the USFans Store',
  'shipping.backHome': 'Back to Homepage',
};